(() => {
  angular
    .module('complianceFrameworkApp.socialMediaCompliance')
    .controller('NewFanPageController', NewFanPageController);

  /* ngInject */
  function NewFanPageController($state, $stateParams, Flash, fanPageService, smcProfileService, sessionService) {
    const vm = this;

    vm.addFanPage = addFanPage;
    vm.administeredFanPages = [];
    vm.profile = {};
    vm.profileId = $stateParams.profileId;

    activate();

    function activate() {
      getAdministeredFanPages();
      getProfile();
    }

    function addFanPage(fanPageId) {
      fanPageService(sessionService.getAuthToken()).create({ profileId: vm.profileId }, { fan_page_id: fanPageId }, _ => {
        $state.go('application.social_media_compliance.fan_pages', { profileId: vm.profileId });
        Flash.create('success', 'Fan page successfully updated.');
      },
      _ => {
        Flash.create('danger', 'An error occurred with the submission. Please correct the following errors on the form and resubmit.');
      });
    }

    function getAdministeredFanPages() {
      fanPageService(sessionService.getAuthToken()).administered({ profileId: vm.profileId }, response => {
        vm.administeredFanPages = response;
      });
    }

    function getProfile() {
      smcProfileService(sessionService.getAuthToken()).get({ id: vm.profileId }, response => vm.profile = response);
    }
  }
})();
